import Api from "../../../../core/data/redux/utils/apiCall";
import { API_URLS } from "../../../../core/data/redux/apis/urls";

export interface TaxCardLine {
  Tableline?: string;
  EmpID?: string;
  Year?: string;
  [key: string]: any;
}

function unwrapList(res: any): any[] {
  const root = res?.data ?? res;
  const raw = root?.data ?? root;
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.data)) return raw.data;
  if (Array.isArray(raw?.list)) return raw.list;
  if (Array.isArray(root)) return root;
  return [];
}

function toError(err: any, fallback: string): Error {
  const msg =
    err?.response?.data?.data?.message ||
    err?.response?.data?.message ||
    err?.message ||
    fallback;
  return new Error(typeof msg === "string" ? msg : fallback);
}

export function getYearOptions(count = 10): string[] {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: count }, (_, i) => String(currentYear - i));
}

export function getCurrentYear(): string {
  return String(new Date().getFullYear());
}

export async function fetchTaxCard(year: string): Promise<TaxCardLine[]> {
  try {
    const res: any = await Api.post(API_URLS.TAX_CARD.FETCH, {
      year,
      action: "DISPLAY_TAX_CARD",
    });

    const root = res?.data ?? res;
    if (res?.success === false || root?.success === false) {
      throw new Error(
        res?.message || root?.message || "Failed to fetch tax card data"
      );
    }
    return unwrapList(res);
  } catch (err: any) {
    throw toError(err, "An error occurred while fetching tax card data");
  }
}
